// react
import React, { useEffect, useState } from 'react';

// third-party
import classNames from 'classnames';
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

// application
import AsyncAction from '../shared/AsyncAction';
import Currency from '../shared/Currency';
import Indicator from './Indicator';
import { Cart20Svg, Cross10Svg } from '../../svg';
import { cartRemoveItem } from '../../store/cart';
import { url } from '../../services/utils';
import axios from 'axios';
import { updateAction } from '../../store/auth/authActions';
import { toast } from 'react-toastify';

import { getCartList, updateCartCache, clearCartCache } from '../../services/cartService';

function IndicatorCart(props) {
    const { token, updateStatus } = props;
    const [cart, setProduct] = useState([]);
    const [productId, setProductId] = useState(false);
    const [cartTotal, setCartTotal] = useState(() => {
        const saved = localStorage.getItem('cart_total');
        return saved !== null ? parseInt(saved, 10) : 0;
    });
    const [priceTotal, setPriceTotal] = useState(0);
    const [loadingCO, setLoadingCO] = useState(false);
    let dropdown;
    let totals;
    
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        const handleRealtimeCartCount = (e) => {
            const count = typeof e?.detail === 'number'
                ? e.detail
                : (typeof e?.detail?.count === 'number'
                    ? e.detail.count
                    : parseInt(localStorage.getItem('cart_total') || '0', 10));
            setCartTotal(count);
        };
        window.addEventListener('cart:count_updated', handleRealtimeCartCount);
        return () => {
            window.removeEventListener('cart:count_updated', handleRealtimeCartCount);
        };
    }, []);

    useEffect(() => {
        const getCart = async () => {
            if (!token) {
                setProduct([]);
                setProductId([]);
                setCartTotal(0);
                setPriceTotal(0);
                return;
            }
            try {
                const { items, total } = await getCartList(token);
                setProduct(items);
                setProductId(items.map((item) => item.id));
                setCartTotal(total);
                const sumPrice = items.reduce((acc, curr) => acc + (parseFloat(curr.sub_total) || 0), 0);
                setPriceTotal(sumPrice);
            } catch (error) {
                setProduct([]);
                setProductId([]);
                setCartTotal(0);
                setPriceTotal(0);
            }
        };

        getCart();
    }, [token, updateStatus]);

    const cartRemoveItem = async (id, body) => {
        // Optimistic instant removal from dropdown
        const updated = cart.filter((item) => String(item.id) !== String(id));
        setProduct(updated);
        const { total } = updateCartCache(updated);
        setCartTotal(total);
        window.dispatchEvent(new CustomEvent('cart:count_updated', { detail: total }));

        try {
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/cart/delete/${id}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: body,
            });
            toast.success('Product removed');
            updateCartCache(updated);
            window.dispatchEvent(new CustomEvent('cart:count_updated', { detail: total }));
        } catch (error) {
            console.log(error);
            toast.error('There was an error removing the product');
            clearCartCache();
            const { items, total: fallbackTotal } = await getCartList(token, true);
            setProduct(items);
            setCartTotal(fallbackTotal);
        }
    };

    const formatRupiah = (money) => {
        return new Intl.NumberFormat('id-ID',
            { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
        ).format(money);
      }

    // const checkoutHandler= ()=>{
        
    //           history.push('/shop/checkout')
        
    // }

    // const checkoutHandler = async (body) => {
    //     const { token, history, dispatch, } = this.props;    
    //     const user_code = localStorage.getItem('user_code');
    //     // let bank_id = this.state.listBank.find(x => x.bank_name == this.state.currentPayment).id;
    
    
    //     let param = {
    //       user_code : user_code,
    //       list_cart : body.cart_id
    //     }
    
    //     try {
    //       this.setState({ loadingCO: true });
    //       const result = await axios({
    //         method: 'POST',
    //         url: `${process.env.REACT_APP_HOST_API}/so-commerce/do-checkout`,
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //         data: param,
    //       });
    //       this.setState({ loadingCO: false });
    //       console.log(result.data.response);
    //       localStorage.setItem('CO-INFO', JSON.stringify(result.data.response));
    //       toast.success(`${result.data.response}`);
    //       this.setState({ paid: true });
    //       dispatch(updateAction(true));
    //       setTimeout(() => {
    //         dispatch(updateAction(false));
    //       }, 1000);
    //       history.push('/shop/checkout');
    //     //   this.props.history.push('/shop/checkout')
    //     } catch (error) {
    //       this.setState({ loadingCO: false });
    //       console.log(error);
    //       toast.error(error.message);
    //     }
    //   };
    
    // if (cart.extraLines.length > 0) {
    //     const extraLines = cart.extraLines.map((extraLine, index) => (
    //         <tr key={index}>
    //             <th>{extraLine.title}</th>
    //             <td><Currency value={extraLine.price} /></td>
    //         </tr>
    //     ));

        totals = (
            
            <React.Fragment>
                <tr>
                    <th>Sub Total</th>
                    <td>{formatRupiah(priceTotal)}</td>
                </tr>
                {/* {extraLines} */}
            </React.Fragment>
        );
    // }

    const items = cart.map((item) => {
        let options;
        let image;

        // if (item.options) {
        //     options = (
        //         <ul className="dropcart__product-options">
        //             {item.options.map((option, index) => (
        //                 <li key={index}>{`${option.optionTitle}: ${option.valueTitle}`}</li>
        //             ))}
        //         </ul>
        //     );
        // }

        if (item) {
            image = (
                <div className="product-image dropcart__product-image">
                    <Link to={url.product({ ...item, id: item.id_is || item.id })} className="product-image__body">
                        <img className="product-image__img" src={item.image_url} alt="" />
                    </Link>
                </div>
            );
        }

        const removeButton = (
            <AsyncAction
                action={() => cartRemoveItem(item.id,{qty:0})}
                render={({ run, loading }) => {
                    const classes = classNames('dropcart__product-remove btn btn-light btn-sm btn-svg-icon', {
                        'btn-loading': loading,
                    });

                    return (
                        <button type="button" onClick={run} className={classes}>
                            <Cross10Svg />
                        </button>
                    );
                }}
            />
        );

        return (
            <div key={item.id} className="dropcart__product">
                {image}
                <div className="dropcart__product-info">
                    <div className="dropcart__product-name">
                        <Link to={url.product({ ...item, id: item.id_is || item.id })}>{item.item_name}</Link>
                    </div>
                    {options}
                    <div className="dropcart__product-meta">
                        <span className="dropcart__product-quantity">{item.qty}</span>
                        {' × '}
                        <span className="dropcart__product-price">{formatRupiah(item.price_6)}</span>
                    </div>
                </div>
                {removeButton}
            </div>
        );
    });

    // const formatRupiah = (money) => {
    //     return new Intl.NumberFormat('id-ID',
    //         { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
    //     ).format(money);
    //   }

    if (cart.length>0) {
        dropdown = (
            <div className="dropcart">
                <div className="dropcart__products-list">
                    {items}
                </div>

                <div className="dropcart__totals">
                    <table>
                        <tbody>
                            {totals}
                            <tr>
                                <th>Total</th>
                                <td>{formatRupiah(priceTotal)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="dropcart__buttons">
                    <Link className="btn btn-secondary" to="/shop/cart">Keranjang</Link>
                    {/* <div className={classNames("btn btn-primary",{'btn-loading': loadingCO})} onClick={() => {
                            checkoutHandler();
                          }}>Checkout</div> */}
                </div>
            </div>
        );
    } else {
        dropdown = (
            <div className="dropcart">
                <div className="dropcart__empty">
                Keranjangmu Kosong, yuk belanja dulu!
                </div>
            </div>
        );
    }

    const handleCartClick = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (!token) {
            history.push('/account/login');
        } else {
            history.push('/cart');
        }
    };

    return (
        <Indicator
            className="indicator--cart"
            url="/cart"
            value={cartTotal > 0 ? cartTotal : undefined}
            icon={<Cart20Svg />}
            onClick={handleCartClick}
        />
    );
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    token: state.auth.token,
    updateStatus: state.auth.update,
});

const mapDispatchToProps = {
    cartRemoveItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorCart);
